import * as angular from "angular";
import { BaseModel, ModelBase, modelModule, AtonixAuthenticationService } from "./model";
import "./model";
import '../Logging/Logger';
import { Logger } from '../Logging/Logger';

export class AccountModel extends ModelBase {
	constructor( $http: ng.IHttpService, $q: ng.IQService, $log: ng.ILogService,
		private $window: Window, baseModel: BaseModel, private atonixAuthenticationService: AtonixAuthenticationService, private logger: Logger) {
		super("api/Account/", $http, $q,$log, baseModel);
	}

	//This is only used to add watches on $scope of the controllers.  
	//This should never be changed except in the setter of the localUser property. 
	public getCachedUser() {
		return this.baseModel.localUser();
	};

	public clearCachedUser() {
		this.baseModel.clearCachedUser();
	}

	public saveUserToCache(myUser:model.IUser) {
		this.baseModel.localUser(myUser);
	}


	//Get rid of the caches of the user and clear the authorization token. 
	public logout() {
		this.atonixAuthenticationService.LogOut(); 
		this.baseModel.removeLocalData();
		this.logger.clearUser(); 
	};

	public getAWSUser() {
		var userinfoDeferred: ng.IDeferred<model.IAWSUserInfo> = this.$q.defer();

		this.atonixAuthenticationService.GetAccessToken().then((accessToken) => {
			return this.$http.get<model.IAWSUserInfo>(this.GetUrl('UserAccount'), { params: { token: accessToken } })
		}).then(data => {
			userinfoDeferred.resolve(data.data);
		}).catch(error => {
			userinfoDeferred.reject(error);
		}); 

		return userinfoDeferred.promise;
	}

	public getUserProfile() {
		var deferred: ng.IDeferred<model.IAccountModelUser> = this.$q.defer();

		this.$http.get<model.IAccountModelUser>(this.GetUrl('UserInfo'))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((err) => {
				deferred.reject(err)
			});

		return deferred.promise;
	}

	//This is the method that will get the user information.  This will be the primary indication of whether a user is
	//logged in or not.  If they are not logged in the view can disable itself.  
	public getUserInfo(force: boolean = false) {
		var userinfoDeferred: ng.IDeferred<model.IUser> = this.$q.defer();
		
		var myUser = this.baseModel.localUser();
		
        if (myUser && myUser.UserName && !force) {            
			userinfoDeferred.resolve(myUser);
		}
		else {
			//Grab the user from the service.  This will only work once the user is logged in. 
			this.$http.get<model.IAccountModelUser>(this.GetUrl('UserInfo'))
				.then((data) => {
					var userWithCorrectType: model.IUser = {
						AutoGenerated:false,
						Email:data.data.Email,
						Enabled:true,
						FirstName:data.data.FirstName,
						GlobalId:'',
						IsBVEmployee:data.data.IsBV,
						IsGroupSub:false,
						LastName:data.data.LastName,
						SecurityUserID:0,
						UserName: data.data.UserName,
						NERCCIP: data.data.NERCCIP,
						ServiceAccount: data.data.ServiceAccount,
						UserValidated: data.data.UserValidated
					};

					this.baseModel.localUser(userWithCorrectType);
					userinfoDeferred.resolve(userWithCorrectType);
				})
				.catch((data) => {
					this.baseModel.clearCachedUser(); 
					this.$log.info(data.message || data.Message || data)
					userinfoDeferred.reject('Failed to get user');
					this.LogError("getUserInfo",data);
					if (data.status != 403) {
						//Don't log the user out if they are just trying to access an app they don't have access to. 
						this.logout();
					}

				});
		}

		return userinfoDeferred.promise;
	}

	public saveUserInfo (userInfo) {
		var myUserInfo = {
			'FirstName': userInfo.FirstName, 'LastName': userInfo.LastName
		};
		return this.$http.post(this.GetUrl("UserInfo"), myUserInfo);
	};

	public isUserFederated(username: string) {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http.get<boolean>(this.GetUrl("IsUserFederated"), {
			headers: { 'Anonymous': true },
			params: {
				username: username
			}
		})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("isUserFederated", data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}

	public initializeUser(email: string) {
		var deferred = this.$q.defer();

		this.$http.get(this.GetUrl('InitializeUser'), {
			headers: { 'Anonymous': true },
			params: { 'email': email }
		})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((err) => {
				deferred.reject(err);
			});

		return deferred.promise;
	}

	public changePassword(username: string, oldPassword: string, newPassword1: string, newPassword2: string) {
		var deferred = this.$q.defer();

		var d = {
			'UserName': username, 'Password': oldPassword, 'NewPassword': newPassword1, 'ConfirmPassword': newPassword2
		};

		this.$http.post(this.GetUrl('ChangePassword'), d, { headers: { 'Anonymous':true }})
			.then( (data) => {
				deferred.resolve(data);

			})
			.catch((err) => {
				deferred.reject(err);
			});

		return deferred.promise;
	};

	public GetUserPreferences() {
		var deferred: ng.IDeferred<model.IUserPreferences> = this.$q.defer(); 
		this.$http.get<model.IUserPreferences>(this.GetUrl('UserPreferences'))
			.then((data) => {
				deferred.resolve(data.data); 
			})
			.catch((err) => {
				this.LogError("GetUserPreferences", err); 
				deferred.reject(err); 
			});

		return deferred.promise; 
    }
    //this gets the currency for the user from the backend. 
    //used in issues tab. 
    public GetUserCurrency() {
        var deferred: ng.IDeferred<string> = this.$q.defer();
        this.$http.get<string>(this.GetUrl('UserCurrency'))
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("GetUserCurrency", err);
                deferred.reject(err);
            });

        return deferred.promise;
    }

	public validateNewPassword(password:string) {
		var deferred: ng.IDeferred<model.IPasswordValidationResult> = this.$q.defer();
		this.$http.get<model.IPasswordValidationResult>(this.GetUrl('CheckPassword'), { params: { password: password }, headers: { 'Anonymous':true } })
			.then( (data) => {
				deferred.resolve(data.data);
			})
			.catch((err) => {
				deferred.reject(err);
			});

		return deferred.promise;
	}

	//FIX ME: I don't think this is working as designed.
	public isLoggedIn = () => {
		return this.baseModel.isAuthorized();
	};

	public getAXToken() {
		return this.baseModel.getAXToken(); 
	}

	public getUsersForAsset(assetID: number) {
		var deferred: ng.IDeferred<model.IUserInfoModel[]> = this.$q.defer();
		this.$http.get<model.IUserInfoModel[]>(this.GetUrl('UsersForAsset'), { params: { assetID: assetID } })
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((err) => {
				this.LogError("getUsersForAsset", err);
				deferred.reject(err.data);
			});

		return deferred.promise;
	}

	public sendWorkpackage(subject: string, body: string, recipients: model.IUserInfoModel[]) {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();
		this.$http.post<boolean>(this.GetUrl('SendWorkpackage'), {
			Subject: subject,
			Body: body,
			Recipients:recipients
		})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((err) => {
				this.LogError("sendWorkpackage", err);
				deferred.reject(err.data);
			});

		return deferred.promise;
	}

	///This method will tell the server that the user has been authenticated.
	//It will give the back end a chance to write an entry to the AccessControl.tAuthenticationHistory
	//table indicating that the user was authenticated and when.  
	public userAuthenticated() {
		var deferred: ng.IDeferred<null> = this.$q.defer(); 

		this.$http.get<{ GlobalId: string, CustomerID:string }>(this.GetUrl('UserAuthenticated'))
			.then((data) => {
				this.logger.setUser(data.data.GlobalId, data.data.CustomerID);
				deferred.resolve();
			})
			.catch((err) => {
				this.LogError('userAuthenticated', err);
				deferred.reject(err.data); 
			})

		return deferred.promise;
	}


}

modelModule.factory('accountModel', ['$http', '$q', '$log', '$window', 'baseModel', 'AtonixAuthenticationService','Logger', ($http, $q, $log, $window, baseModel, AtonixAuthenticationService, logger) => new AccountModel($http, $q, $log, $window, baseModel, AtonixAuthenticationService, logger)]);


// WEBPACK FOOTER //
// ./Common/Models/AccountModel.ts